export const M3H = 1;
export const LS = 2;
export const TOTAL_P = 1;
export const STATIC_P = 2;
export const NOISE_1m = 1;
export const NOISE_3m = 3;

export const MODEL_STANDARD = 1;
export const MODEL_FIRE = 3;
export const MODEL_EXP = 2;

export const getNoise = (fan, form) => {
  if (form['noise'] === NOISE_1m) {
    return fan.noise_1m;
  }
  return fan.noise_3m;
};

export const getVolume = (fan, form) => {
  if (form['volumeType'] === M3H) return fan.fan_air_volume;
  const val = (fan.fan_air_volume * 10) / 36;
  return Math.round(val);
};

export const getModelName = (fan, modelType) => {
  if (modelType === MODEL_STANDARD) return fan.standard_fan_type;
  if (modelType === MODEL_EXP) return fan.prevention_fan_type;
  if (modelType === MODEL_FIRE) return fan.fire_fan_type;
  return fan.standard_fan_type;
};

export const getFileName = (fan) => {
  const modelName = getModelName(fan, fan.configs.modelTypeSelect);
  const inputVolume = fan.configs.volume;
  const pa =
    fan.configs.pressureType == 1
      ? fan.fan_total_pressure
      : fan.fan_static_pressure;

  return `${modelName.replaceAll('/', '_')}-${inputVolume}@${pa}`;
};
